var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductSc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 45",
    style: {
      enableBackground: "new 0 0 42 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.psc{fill:#2FC3EB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "psc",
    d: "M29.7,19.9c-0.2,0-0.4,0.2-0.4,0.4V21c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-0.6 C30.1,20.1,29.9,19.9,29.7,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "psc",
    d: "M29.2,14.1v4.1c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-4.1c0-0.2-0.2-0.4-0.4-0.4 C29.4,13.7,29.2,13.9,29.2,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "psc",
    d: "M21,1.5c-11.6,0-21,9.4-21,21s9.4,21,21,21s21-9.4,21-21S32.6,1.5,21,1.5z M9.1,18h14.3 c0.2,1.7,0.9,3.4,2.1,4.7l-0.8,0.7L19.3,28c-0.7,0.6-1.7,0.6-2.4,0l-9.9-8.3C7.3,18.7,8.1,18,9.1,18z M29.2,25.2v6.9 c0,0.4-0.1,0.7-0.3,1l-5.4-5.5c-0.1-0.1-0.3-0.2-0.4-0.1c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0,0.3,0.1,0.4l5.4,5.5 c-0.4,0.3-0.8,0.4-1.3,0.4H9.1c-0.5,0-0.9-0.1-1.3-0.4l5.4-5.5c0.1-0.1,0.2-0.3,0.1-0.4c0-0.2-0.2-0.3-0.3-0.3 c-0.2,0-0.3,0-0.4,0.1l-5.4,5.5c-0.2-0.3-0.3-0.7-0.3-1V20.8l9.3,7.9c1,0.9,2.5,0.9,3.6,0l5.5-4.6c0,0,0,0,0,0l0.8-0.7 c0.7,0.6,1.5,1.2,2.4,1.6L29.2,25.2C29.2,25.2,29.2,25.2,29.2,25.2z M35,16.9c0,3.1-1.9,5.9-4.7,7.1l0,0l-0.7,0.3L28.9,24 c-2.8-1.2-4.6-4-4.6-7v-3.3l5.2-2.9l5.4,2.9V16.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSc);
export default __webpack_public_path__ + "static/media/product-sc.322c8069e5f83477e507d09b538045bf.svg";
export { ForwardRef as ReactComponent };